import { Grid, Typography } from "@material-ui/core";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import { COLORS } from "constants/colors";
import { OrderStatusList, ParcelStatusList } from "constants/status";
import useText from "constants/text";
import React from "react";
import "styled-components/macro";
import { DateFilter } from "./DateFilter";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    spacing: {
      marginTop: "auto",
      marginBottom: "auto",
      marginLeft: 15,
    },
    root: {
      paddingTop: "2%",
      display: "flex",
      justifyContent: "space-between",
    },
    title: {
      fontSize: 24,
      marginTop: 5,
      fontFamily: "Montserrat",
      fontWeight: "bold",
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: "normal",
      letterSpacing: "normal",
      color: "#1a224b",
      [theme.breakpoints.down("xs")]: { position: "relative", top: -17, left: -17 },
    },
    search: {
      marginLeft: "auto",
      [theme.breakpoints.down("xs")]: {
        position: "relative",
        left: 2,
        marginLeft: 0,
      },
    },
    filterStyled: {
      display: "block",
      color: COLORS.primary,
      marginLeft: "10px",
      [theme.breakpoints.down("xs")]: { marginLeft: "10px" },
    },
  })
);
export interface HeaderSectionProps {
  children?: React.ReactNode;
  statusKey?: string;
  checked?: boolean;
}
export function HeaderParcelTracking({ children, statusKey, checked }: HeaderSectionProps) {
  const styles = useStyles();
  const [statusOption, setStatusOption] = React.useState([]);
  const { text } = useText();

  React.useEffect(() => {
    if (!checked) {
      setStatusOption(ParcelStatusList[statusKey]);
    } else {
      setStatusOption(OrderStatusList[statusKey]);
    }
  }, [checked, statusKey]);

  return (
    <>
      <Grid container className={styles.root}>
        <Grid item xs={12} sm={6} md={6}>
          <Typography className={styles.title}>{text.parcel.parcels_tracking}</Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={6} style={{ display: "flex", marginTop: "10px", marginLeft: -19 }}>
          <div className={styles.search}>{children}</div>
          <div className={styles.filterStyled}>
            <DateFilter status={statusOption} statusKey={statusKey} />
          </div>
        </Grid>
      </Grid>
    </>
  );
}
